export const ArrowRightAltIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
    >
        <path d="M18.6031 12.3531L18.9563 12L18.6031 11.6469L13.3531 6.39687L13 6.04375L12.2937 6.75L12.6469 7.10312L17.0437 11.5H5.5H5V12.5H5.5H17.0437L12.6469 16.8969L12.2937 17.25L13 17.9562L13.3531 17.6031L18.6031 12.3531Z" />
    </svg>
);
